import requestInstance from "./Request";
import { API_ENDPOINT } from "./Api";

let env = process.env.REACT_APP_API_BASE_URL;


// Get placard preview service
export const getPlacardPreview = async (payload) => {
  try {
    // If payload contains tripId, use it, otherwise use text
    const requestPayload = payload.tripId
      ? { tripId: payload.tripId }
      : { text: payload.text };

    const response = await requestInstance.post(
      `${env}/trip-api/v3/placard`,
      requestPayload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.success && response.data.data.svgBase64) {
      return {
        success: true,
        imageUrl: `data:image/svg+xml;base64,${response.data.data.svgBase64}`,
      };
    }

    return {
      success: false,
      error: 'No placard data found',
    };
  } catch (error) {
    console.error("Placard preview error:", error);
    throw error;
  }
};